import { alpha } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

export default function Pickers(theme) {
  return {
    // Toolbar
    PrivatePickersToolbar: {
      styleOverrides: {
        root: {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.primary.main,
          '& .MuiTypography-root': {
            color: alpha(theme.palette.common.white, 0.72)
          }
        }
      }
    },
    MuiTimePickerToolbar: {
      styleOverrides: {
        hourMinuteLabelLandscape: {
          margin: 'auto'
        }
      }
    },
    PrivatePickersToolbarText: {
      styleOverrides: {
        selected: { color: `${theme.palette.common.white} !important` }
      }
    },

    // Paper
    PrivatePickersPopper: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z24,
          borderRadius: theme.shape.borderRadiusMd
        }
      }
    },
    MuiPickersStaticWrapper: {
      styleOverrides: {
        root: {
          boxShadow: theme.customShadows.z24,
          borderRadius: theme.shape.borderRadiusMd
        }
      }
    },

    // Tabs
    MuiInternalDateTimePickerTabs: {
      styleOverrides: {
        tabs: {
          '& .MuiTab-root': {
            margin: 0,
            color: alpha(theme.palette.common.white, 0.48),
            '&.Mui-selected': {
              color: theme.palette.common.white
            }
          },
          '& .MuiTabs-indicator': {
            width: `160px !important`,
            backgroundColor: theme.palette.primary.dark
          }
        }
      }
    },

    // Clock
    MuiInternalClock: {
      styleOverrides: {
        root: {
          margin: theme.spacing(5)
        },
        clock: {
          backgroundColor: theme.palette.background.neutral
        }
      }
    }
  };
}
